import moment from "moment";

import { isServer } from "../../core/detection";

/**
 * Common place for cookie names.
 */
export const keys = {
  currencyPref: "user_currency",
};

/**
 * Set a cookie.
 * @param name name of the cookie
 * @param value value of the cookie
 * @param expires datetime the cookie should expire - defaults to session
 * @param path absolute path the cookie applies to - defaults to / (root of domain)
 */
export const setCookie = (name: string, value: string, expires?: moment.Moment, path?: string) => {
  if (isServer()) {
    throw new Error("Cannot set cookies in a server context");
  }

  let cookieString = `${name}=${value}; path=${path || "/"};`;
  if (expires) {
    const expiry = expires.toDate().toUTCString();
    cookieString += ` expires=${expiry};`;
  }

  document.cookie = cookieString;
};

/**
 * Get a value from document.cookie. Browser-only ⚠
 * @param name name of the cookie to get
 */
export const getCookie = (name: string): string => {
  if (isServer()) {
    // See expressServer.tsx for how the isomorphic render gets client cookies.
    throw new Error("Cannot access cookies in a server context");
  }

  // See https://stackoverflow.com/a/25490531 for source of this implementation
  const regexArray = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
  return regexArray ? regexArray.pop() : "";
};
